export default __webpack_public_path__ + "static/media/allo_amea.fb3efab2.svg";